import { API, reviewQS } from "./api";

export const SKY = {
  slug: "ginger-heart-airlines",
  umbrella: "Sir Gingerman's Great Big Adventure",
  title: "Sir Gingerman's Great Big SKY Adventure",
  setting: "Ginger Heart Airlines",
  path: "/adventures/ginger-heart-airlines",
};

// Gallery groups (user-facing) mapped from printable categories.
export const GROUPS = [
  { id: "all", label: "All" },
  { id: "coloring", label: "Coloring", cats: ["coloring"] },
  { id: "puzzles", label: "Puzzles", cats: ["word_search"] },
  { id: "feelings", label: "Feelings", cats: ["sel_worksheet"] },
  { id: "creativity", label: "Creativity", cats: ["activity", "journal"] },
  { id: "certificates", label: "Certificates", cats: ["certificate"] },
];
export const groupOf = (cat) => (GROUPS.find((g) => g.cats?.includes(cat)) || { label: "Covers" }).label;

export const TYPE_LABEL = {
  coloring: "Color Online", drawing: "Draw Online", wordsearch: "Word Search", feelings: "Feelings Activity",
  reflection: "Draw & Write", certificate: "Decorate Certificate", cover: "Welcome Aboard", closing: "Thank You for Flying",
};

const rev = (p) => `v=${p.rev || 0}${reviewQS()}`;
export const pdfHref = (p, download = false) => `${API}${p.file_url}?${rev(p)}${download ? "&download=1" : ""}`;
export const thumbHref = (p) => `${API}${p.thumb_url}?${rev(p)}`;
export const playPath = (p) => `${SKY.path}/play/${p.slug}`;
export const assetHref = (path) => `${API}${path}?x=1${reviewQS()}`;
